import { motion } from 'framer-motion';
import { ExperienceItem } from '../data/portfolioData';

interface TimelineProps {
  items: ExperienceItem[];
  color: string;
}

export default function Timeline({ items, color }: TimelineProps) {
  return (
    <div className="relative pl-6">
      <div
        className="absolute left-2 top-0 bottom-0 w-px"
        style={{ background: `linear-gradient(to bottom, ${color}, transparent)` }}
      />

      {items.map((item, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: i * 0.15, duration: 0.4 }}
          className="relative mb-8 last:mb-0"
        >
          <div
            className="absolute -left-4 top-1.5 w-3 h-3 rounded-full border-2"
            style={{
              borderColor: color,
              background: `${color}40`,
              boxShadow: `0 0 10px ${color}60`,
            }}
          />

          <div
            className="rounded-xl border p-5 backdrop-blur-md"
            style={{
              background: `linear-gradient(135deg, ${color}08, ${color}03)`,
              borderColor: `${color}25`,
            }}
          >
            <div className="flex items-start justify-between gap-3 mb-1">
              <h3 className="text-white font-semibold text-base">{item.role}</h3>
              <span
                className="text-[11px] font-mono whitespace-nowrap mt-1 flex-shrink-0"
                style={{ color }}
              >
                {item.period}
              </span>
            </div>

            <div className="text-sm font-medium mb-1" style={{ color: `${color}cc` }}>
              {item.company}
            </div>

            <p className="text-gray-500 text-xs italic mb-3">{item.subtitle}</p>

            <p className="text-gray-400 text-sm leading-relaxed mb-3">{item.description}</p>

            {item.bullets && (
              <ul className="space-y-2">
                {item.bullets.map((bullet, j) => (
                  <li key={j} className="flex gap-2 text-gray-400 text-xs leading-relaxed">
                    <span className="mt-1.5 w-1 h-1 rounded-full flex-shrink-0" style={{ background: color }} />
                    {bullet}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </motion.div>
      ))}
    </div>
  );
}
